import RunningPartnershipsLine from "./RunningPartnershipsLine";

export default RunningPartnershipsLine;